module.exports = __webpack_public_path__ + "static/media/Homebanner2.85621f48.png";